import { ShieldCheck, Landmark, FileCheck2 } from "lucide-react";
import { Link } from "react-router-dom";
import { GOVT_PORTALS } from "../data/content";

export const TrustSeal = () => (
  <section className="py-24 md:py-32 bg-[#F9FAFA]" data-testid="trust-seal-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
      <div className="flex justify-center lg:justify-start">
        <div data-testid="trust-seal-badge" className="relative w-72 h-72 rounded-full border border-[#C1A74A] flex items-center justify-center">
          <div className="absolute inset-3 rounded-full border border-[#C1A74A]/40" />
          <div className="flex flex-col items-center text-center px-10">
            <img src="/logo-emblem-gold.png" alt="Terraa & Title emblem" className="h-16 w-auto" />
            <p className="font-heading text-[0.68rem] tracking-[0.32em] uppercase text-[#113835] mt-4 font-semibold">Source Verified</p>
            <p className="font-accent italic text-sm text-[#C1A74A] mt-1">by Terraa &amp; Title</p>
            <p className="text-[0.55rem] tracking-[0.22em] uppercase text-gray-400 mt-3">Govt Records · Scored /1000</p>
          </div>
        </div>
      </div>
      <div>
        <p className="tt-eyebrow mb-4">The Terraa Standard</p>
        <h2 className="font-heading text-3xl md:text-5xl font-medium tracking-tight text-[#113835]">
          Every report carries the <span className="font-accent italic text-[#C1A74A]">Source Verified</span> seal.
        </h2>
        <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-gray-600">
          Before a Terraa Score report leaves our desk, each finding is checked against the government record itself —
          not summaries, not databases.
        </p>
        <ul className="mt-8 space-y-4">
          <li className="flex items-start gap-4">
            <Landmark size={20} strokeWidth={1.25} className="text-[#C1A74A] mt-0.5 shrink-0" />
            <span className="text-sm text-gray-600 font-light">7/12, 8A, and property card verified on <strong className="text-[#113835] font-medium">MahaBhulekh</strong>; registrations and encumbrances on <strong className="text-[#113835] font-medium">IGR e-Search</strong>.</span>
          </li>
          <li className="flex items-start gap-4">
            <FileCheck2 size={20} strokeWidth={1.25} className="text-[#C1A74A] mt-0.5 shrink-0" />
            <span className="text-sm text-gray-600 font-light">Digitally signed copies obtained via <strong className="text-[#113835] font-medium">Digital Satbara</strong> and annexed to your report.</span>
          </li>
          <li className="flex items-start gap-4">
            <ShieldCheck size={20} strokeWidth={1.25} className="text-[#C1A74A] mt-0.5 shrink-0" />
            <span className="text-sm text-gray-600 font-light">The property is rated with the <strong className="text-[#113835] font-medium">Terraa Score</strong> — a weighted due diligence rating out of 1000 across six risk categories.</span>
          </li>
        </ul>
        <Link to="/request-title-search" data-testid="trust-seal-cta" className="tt-btn-primary mt-10">
          Get Your Verified Report
        </Link>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-20">
      <p className="tt-eyebrow mb-8" data-testid="portals-heading">Government Portals We Check</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#113835]/10 border border-[#113835]/10" data-testid="portals-grid">
        {GOVT_PORTALS.map((p) => (
          <div key={p.name} className="bg-white p-6">
            <p className="font-heading text-[0.78rem] font-semibold text-[#113835] tracking-wide">{p.name}</p>
            <p className="text-xs text-gray-500 font-light mt-2 leading-relaxed">{p.what}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
